import React from 'react';
import PropTypes from 'prop-types';
import { DialogContent, DialogContentText } from '@mui/material';
import { Link } from 'react-router-dom';
import {
  CancelButton,
  OkButton,
  StyledDialogActions,
  StyledConfirmDialog,
  TagTextField,
  StatusChip,
  StyledDialogTitle,
} from './utils';

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  askingMessage,
  navigationPath,
  notificationList,
  confirmationMessage,
  editTag,
  newTag,
  setNewTag,
  tagError,
  setTagError,
}) => {
  let dialogTitleContent = null;
  let statusChipLabel = '';
  let statusChipStatus = '';

  if (notificationList?.document) {
    dialogTitleContent = notificationList?.document?.name;
    statusChipLabel =
      notificationList?.document?.status === 'Failed' ? 'Failed' : 'Completed';
    statusChipStatus = notificationList?.document?.status;
  } else if (notificationList?.flow) {
    dialogTitleContent = notificationList?.flow?.name;
    statusChipLabel =
      notificationList?.flow?.status === 'Stopped' ? 'Stopped' : 'Running';
    statusChipStatus = notificationList?.flow?.status;
  } else if (notificationList?.OrganizationSubscription) {
    dialogTitleContent = `Plan : ${notificationList?.OrganizationSubscription?.pricingPlan?.name}`;
    statusChipLabel =
      notificationList?.OrganizationSubscription?.status === 'inactive'
        ? 'Inactive'
        : 'Active';
    statusChipStatus = notificationList?.OrganizationSubscription?.status;
  } else if (notificationList?.payment) {
    dialogTitleContent = 'Credits';
  }

  return (
    <StyledConfirmDialog open={open} onClose={onClose}>
      {dialogTitleContent && (
        <StyledDialogTitle>
          {dialogTitleContent}
          {statusChipLabel && (
            <StatusChip
              size="small"
              label={statusChipLabel}
              status={statusChipStatus}
            />
          )}
        </StyledDialogTitle>
      )}
      <DialogContent
        sx={{
          display:
            notificationList !== null || askingMessage ? 'block' : 'none',
        }}
      >
        <DialogContentText id="alert-dialog-description">
          {askingMessage}
        </DialogContentText>
        <DialogContentText id="alert-dialog-description">
          {confirmationMessage}
        </DialogContentText>

        {editTag && (
          <TagTextField
            fullWidth
            size="small"
            id="outlined-basic"
            variant="outlined"
            value={newTag}
            error={Boolean(tagError)}
            helperText={tagError}
            onChange={(event) => {
              const tag = event.target.value;
              setNewTag(tag);
              // Add your validation logic here
              if (tag.trim() === '') {
                setTagError('Tag cannot be empty');
              } else {
                setTagError('');
              }
            }}
          />
        )}
      </DialogContent>
      <StyledDialogActions>
        {askingMessage ? (
          <CancelButton onClick={onClose}>Cancel</CancelButton>
        ) : null}

        {askingMessage && navigationPath ? (
          <Link
            className="removeLinkUnderline"
            to={navigationPath}
            rel="noopener noreferrer"
          >
            <OkButton onClick={onConfirm}>Ok</OkButton>
          </Link>
        ) : (
          <OkButton onClick={onConfirm}>Ok</OkButton>
        )}
      </StyledDialogActions>
    </StyledConfirmDialog>
  );
};

ConfirmDialog.defaultProps = {
  navigationPath: null,
  notificationList: null,
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  askingMessage: PropTypes.string.isRequired,
  navigationPath: PropTypes.string,
  notificationList: PropTypes.string,
  confirmationMessage: PropTypes.string.isRequired,
  editTag: PropTypes.bool.isRequired,
  newTag: PropTypes.string.isRequired,
  setNewTag: PropTypes.func.isRequired,
  tagError: PropTypes.string.isRequired,
  setTagError: PropTypes.func.isRequired,
};

export default ConfirmDialog;
